import React, { useMemo } from "react";
import {
  Button,
  CopyToClipboard,
  Divider,
  TableAdv,
} from "../../../../../components";
import { formatWords2 } from "../../../../../utils/stringUtils";

const data = [
  {
    companyName: "Tek Tree",
    jobTitle: "Fullstack Developer",
    jobDescription: "Job description goes here",
    contactDetails: [
      {
        name: "hrithik",
        designation: "HR",
        email: "hr@tt.inc",
        phone: "7643878347",
        location: "hyd",
      },
      {
        name: "hrithik",
        designation: "HR",
        email: "hr@tt.inc",
        phone: "7643878347",
        location: "hyd",
      },
    ],
  },
  {
    companyName: "Tek Tree",
    jobTitle: "Fullstack Developer",
    contactDetails: "",
    jobDescription: "Job description goes here",
  },
  {
    companyName: "Tek Tree",
    jobTitle: "Fullstack Developer",
    contactDetails: "",
    jobDescription: "Job description goes here",
  },
  {
    companyName: "Tek Tree",
    jobTitle: "Fullstack Developer",
    contactDetails: "",
    jobDescription: "Job description goes here",
  },
];

function getSiteName(url) {
  try {
    const { hostname } = new URL(url);
    let name = hostname
      .replace(/^www\./, "")
      .split(".")[0]
      .replace(/-/g, " ");
    name = name.charAt(0).toUpperCase() + name.slice(1);
    return name;
  } catch {
    return "Link";
  }
}

const MyLeadsPreview = ({ previewData = [], onEdit, onDelete }) => {
  // console.log("previewData",previewData)

  const validatedRows = useMemo(() => {
    // 1. Identify all emails and their occurrences to find duplicates
    const emailCounts = {};
    previewData.forEach((row) => {
      const contacts = row?.contactDetails || [];
      contacts.forEach((contact) => {
        const emailValue =
          typeof contact?.email === "string"
            ? contact.email
            : contact?.email?.email;
        const email = emailValue?.toLowerCase();

        if (email) {
          emailCounts[email] = (emailCounts[email] || 0) + 1;
        }
      });
    });

    // 2. Map and validate each row
    return previewData.map((item, index) => {
      if (index === 0) console.log("Debug: Full Row Structure", item); // Log first row once
      const errors = [];

      // Mandatory field validation
      if (!item?.jobTitle || item?.jobTitle === "-")
        errors.push("Job Title is mandatory");
      if (!item?.industry || item?.industry === "-")
        errors.push("Industry is mandatory");
      if (!item?.jobLocation || item?.jobLocation === "-")
        errors.push("Location is mandatory");
      if (!item?.website || item?.website === "-")
        errors.push("Website is mandatory");

      // Duplicate email validation
      const contacts = item?.contactDetails || [];
      const hasDuplicateEmail = contacts.some((contact) => {
        const emailValue =
          typeof contact?.email === "string"
            ? contact.email
            : contact?.email?.email;
        const email = emailValue?.toLowerCase();
        return email && emailCounts[email] > 1;
      });

      if (hasDuplicateEmail) {
        errors.push("Duplicate email address found in another row");
      }

      // Missing Contact Info Validation
      const contactsList = item?.contactDetails || [];
      let hasMissingContactInfo = false;

      if (contactsList.length === 0) {
        hasMissingContactInfo = true;
      } else {
        hasMissingContactInfo = contactsList.some((contact) => {
          const emailValue =
            typeof contact?.email === "string"
              ? contact.email
              : contact?.email?.email;
          const phoneValue =
            typeof contact?.mobile === "string"
              ? contact.mobile
              : contact?.mobile?.number || contact?.phone;

          const isEmailMissing = !emailValue || emailValue === "-" || (typeof emailValue === 'string' && emailValue.trim() === "");
          const isPhoneMissing = !phoneValue || phoneValue === "-" || (typeof phoneValue === 'string' && phoneValue.trim() === "");

          return isEmailMissing && isPhoneMissing;
        });
      }

      if (hasMissingContactInfo) {
        errors.push("Missing both phone number and email (or no contacts found)");
      }

      return {
        ...item, // Preserving all original fields to not break edit/delete
        companyName: formatWords2(item?.companyName) || "-",
        jobTitle: formatWords2(item?.jobTitle) || "-",
        contactDetails: item?.contactDetails || [],
        jobLocation: item?.jobLocation || "-",
        jobDescription: item?.jobDescription || "",
        hasError: errors.length > 0,
      };
    });
  }, [previewData]);

  const companyApprovalStatus = {
    1: "Request Approval",
    2: "Approved",
    3: "Rejected",
  };

  const columns = [
    {
      key: "companyName",
      label: "Account Name",
      columnMenu: false,
      getRowClass: (row) => (row.hasError ? "bg-amber-100" : ""),
      render: (row) => {
        return (
          <div className="flex flex-col gap-2 text-sm">
            <div>

              <div className="font-semibold">
                {row?.companyName || "-"}
              </div>
            </div>

            <div>

              {row?.website ? (
                <a
                  href={row.website}
                  target="_blank"
                  rel="noreferrer"
                  className="text-blue-600 hover:underline break-all"
                >
                  {row.website}
                </a>
              ) : (
                "-"
              )}
            </div>
          </div>
        );
      },
    },
    {
      key: "jobTitle",
      label: "Job Details",
      width: "w-60",
      columnMenu: false,
      render: (row) => {
        return (
          <div className="flex flex-col gap-2 text-sm">
            <div>

              <div className="font-medium">
                {row?.jobTitle || "-"}
              </div>
            </div>

            <div>

              {row?.jobDescription ? (
                <a
                  href={row.jobDescription}
                  target="_blank"
                  rel="noreferrer"
                  className="text-blue-600 hover:underline break-all"
                >
                  {getSiteName(row.jobDescription)}
                </a>
              ) : (
                "-"
              )}
            </div>

            <div>

              <div className="text-gray-700">
                {formatWords2(row?.jobLocation) || "-"}
              </div>
            </div>

          </div>
        );
      },
    },
    {
      key: "contactDetails",
      label: "Contact Details",
      columnMenu: false,
      // minWidth: 400,
      render: (row) => {
        return (
          <div className="flex flex-col gap-2">
            {row?.contactDetails.length > 0 ? (
              row?.contactDetails.map((item, index) => (
                <React.Fragment key={index}>
                  {index === 0}

                  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 text-sm">
                    <div>
                      <div className="font-medium">{formatWords2(item?.name) || "-"}</div>
                      <div className="text-xs text-gray-500">
                        {formatWords2(item?.designation) || "-"}
                      </div>
                    </div>

                    {/* <div className="truncate">
                      {typeof item?.email === "string"
                        ? item.email
                        : item?.email?.email || "-"}
                    </div> */}
                    <div className="min-w-0 col-span-3 flex items-center">
                      <CopyToClipboard
                        title={
                          typeof item?.email === "string"
                            ? item.email
                            : item?.email?.email || "-"
                        }
                        content={
                          typeof item?.email === "string"
                            ? item.email
                            : item?.email?.email || "-"
                        }
                      />
                      <div className="truncate w-full">
                        {typeof item?.email === "string"
                          ? item.email
                          : item?.email?.email || "-"}
                      </div>
                    </div>
                    {/* <SmartTooltip
                      description={
                        typeof item?.email === "string"
                          ? item.email
                          : item?.email?.email || "-"
                      }
                      noicon
                    >
                      <div className="truncate">
                        {typeof item?.email === "string"
                          ? item.email
                          : item?.email?.email || "-"}
                      </div>
                    </SmartTooltip> */}

                    <div>{item?.mobile ? `${item?.mobile?.code || ""}
                     ${item?.mobile?.number || ""}`.trim() : item?.phone ? `${item?.phone?.code || ""} 
                     ${item?.phone?.number || ""}`.trim() : "-"}</div>
                    <div className="truncate">{item.location && typeof item.location === "object" ? [item?.location?.city, item?.location?.state, item?.location?.country,]
                    .filter(Boolean).join(", ") : "-"}</div>
                  </div>

                  {index !== row.contactDetails.length - 1 && <Divider />}
                </React.Fragment>
              ))
            ) : (
              <div>No contact details available</div>
            )}
          </div>
        );
      },
    },
    {
      key: "status",
      label: "Status",
      columnMenu: false,
      render: (row) => {
        const approval = row?.approvalStatus;
        const isToday = new Date(row?.companyAddedOn).toDateString() === new Date().toDateString();

        if (!approval || !approval.isEnabled || !isToday) {
          return <div className="text-sm">-</div>;
        }

        const statusText = companyApprovalStatus[approval.status] || "-";

        return (
          <div className="flex flex-col gap-2 text-sm">
            {statusText}
          </div>
        );
      },
    },
    {
      key: "",
      label: "Actions",
      // width: "w-24",
      render: (row) => (
        <div className="flex items-center justify-center gap-2">
          <Button
            type="icon"
            variant="text"
            icon="edit_square"
            size="xs"
            color="black"
            // onClick={() => onEditJob?.(row)}
            onClick={() => onEdit(row)}
          />
          <Button
            type="icon"
            variant="text"
            icon="delete"
            size="xs"
            color="black"
            onClick={() => onDelete?.(row?.companyId, row?.companyName)}
          />
        </div>
      ),
    },
  ];
  //   const rows = Array.from({ length: data.length }, (_, i) => ({
  //     companyName: data[i]?.companyName || "-",
  //     jobTitle: data[i]?.jobTitle || "-",
  //     contactDetails: data[i]?.contactDetails,
  //     jobLocation: data[i]?.jobLocation || "-",
  //     jobDescription: data[i]?.jobDescription || "",
  //   }));
  const rows = previewData.map((item) => ({
    companyName: formatWords2(item?.companyName) || "-",
    companyId: item?.companyId,
    jobId: item?.jobId,
    jobTitle: item?.jobTitle || "-",
    contactDetails: item?.contactDetails || [],
    jobLocation: item?.jobLocation || "-",
    jobDescription: item?.jobDescription || "",
    website: item?.website,
    industry: item?.industry,
    // Explicitly map the comment field so it is available when clicking Edit
    comment: item?.comment,
  }));

  return (
    <div className="flex flex-col overflow-auto">
      <TableAdv
        columns={columns}
        showSlNo
        rows={validatedRows}
        toolbarRight={{
          search: false,
          filter: false,
          download: false,
        }}
      />
    </div>
  );
};

export default MyLeadsPreview;
